import { render, staticRenderFns } from "./DocHubDoc.vue?vue&type=template&id=4dd6a396&"
import script from "./DocHubDoc.vue?vue&type=script&lang=js&"
export * from "./DocHubDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports